import { getWindowSize } from '../utils/helpers';
import { updateLinksAttributes } from '../utils/handleAttributes';
const wrapContainerClass = 'mainCards-wrap-container';

export default function mainCards() {
  const widgetName = 'mainCards';
  const widgetOpts = mainCardsOpts;
  const $widget = $(`#${widgetName}`);
  const isDesktop = getWindowSize(600);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktop ? [] : ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createmainCards(data.items, isDesktop);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createmainCards(widgetData, isDesktop) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);
      const customButton = createButton(URL, Title);

      $cardItem.find('.image-container').append(`
          <div class="card-content">
            <span class="widget-title">${Title}</span>
            <div class="hover-content"></div>
          </div>`);

      $cardItem.find('.hover-content').append(customButton);
      updateCardsMobile(isDesktop, $cardItem, URL, Title);
      validateUrl(URL, $cardItem);
    });
  }
}

function validateUrl(url, $cardItem) {
  if ($cardItem && url === null) {
    $cardItem.addClass('void-url');
  }
  return url !== null;
}

function createButton(url, title) {
  let customButton = '';

  if (validateUrl(url)) {
    const label = `More about ${title}`;
    const attrs = updateLinksAttributes(url, label);
    const link = '<a href="' + url + '" ' + attrs + ' class="button">More</a>';
    customButton = '<div class="widget-button-wrapper">' + link + '</div>';
  }
  return customButton;
}

function updateCardsMobile(isDesktop, $cardItem, URL, Title) {
  if (isDesktop) {
    return;
  } else {
    updateLinksAttributes(URL, Title, $cardItem);
  }
}
